'use strict';

angular.module('ClinicApp').controller('ModalClinicInstantBookOutreach', function($scope, $modalInstance, $window, clinic, canClose, ClinicService, OpencareConstants) {

  $scope.canClose = canClose;
  $scope.clinic = clinic;
  $scope.customerSuccessManagerName = clinic.customerSuccessManager.firstName;

  $scope.checkboxes = [{
    prompt: (
      "You need to continue to check every patient's preferences against your "
      + 'availabilities and manually send them 3 options to choose from.'
    ),
    value: false,
  }, {
    prompt: (
      'You may get fewer appointment requests because patients prefer to book '
      + 'with practices that have Easy Book enabled.'
    ),
    value: false,
  }, {
    prompt: (
      'Your practice may not grow as quickly, as it will take longer to see '
      + 'the same benefits that Easy Book provides.'
    ),
    value: false,
  }];

  $scope.practiceReasonForNotEnablingInstantBook = {
    HAPPY_WITH_PROCESS: false,
    NO_ROOM_FOR_PATIENTS: false,
    EASY_BOOK_WONT_WORK: false,
    OTHER: false,
  };

  $scope.canContactPractice = true;

  $scope.states = {
    pitch: 'PITCH',
    reason: 'REASON',
    confirm: 'CONFIRM',
  };

  $scope.state = $scope.states.pitch;

  function updateMetadata(action) {
    const instantBookOutreachModal = {
      ...clinic.metadata?.instantBookOutreachModal,
      shouldShow: false,
      updatedAt: moment().format(),
      action,
    };
    if ($scope.state === $scope.states.reason) {
      instantBookOutreachModal.practiceReasonForNotEnablingInstantBook = $scope.practiceReasonForNotEnablingInstantBook;
      instantBookOutreachModal.canContactPractice = $scope.canContactPractice;
    }

    return ClinicService.updateClinic(clinic, {
      metadata: {
        instantBookOutreachModal,
      },
    });
  }

  $scope.close = function() {
    return updateMetadata('SKIP')['finally'](function() {
      $modalInstance.close(false);
    });
  };

  $scope.openInstallBooking = function() {
    $window.open(OpencareConstants.calendly.easyBookInquiry, '_blank');

    return updateMetadata('INSTALL_CALL')['finally'](function() {
      $modalInstance.close(false);
    });
  };

  $scope.openDiscussionBooking = function() {
    $window.open(clinic.customerSuccessManager.metadata.bookingLink, '_blank');
    return updateMetadata('DISCUSSION_CALL')['finally'](function() {
      $modalInstance.close(false);
    });
  };

  $scope.setState = function(state) {
    $scope.state = state;
  };

  $scope.toggleCheckbox = function(index) {
    $scope.checkboxes[index].value = !$scope.checkboxes[index].value;
  };

  $scope.toggleCanContactPractice = function() {
    $scope.canContactPractice = !$scope.canContactPractice;
  };

  $scope.toggleReason = function(reason) {
    $scope.practiceReasonForNotEnablingInstantBook[reason] = !$scope.practiceReasonForNotEnablingInstantBook[reason];
  };

  $scope.providedReason = function() {
    return _.any($scope.practiceReasonForNotEnablingInstantBook, function(selected) {
      return selected === true;
    });
  };

  $scope.allCheckboxesChecked = function() {
    return !_.any($scope.checkboxes, function(box) {
      return box.value === false;
    });
  };

});
